import type { CSSProperties, ReactNode } from "react";
import { useEmbedTokens } from "../theme";

interface Props {
  padding?: number | string;
  children: ReactNode;
}

// A raised surface container — the standard panel the embed flows render into.
export function EmbedCard({ padding, children }: Props) {
  const t = useEmbedTokens();
  const style: CSSProperties = {
    background: t.colors.cardBg,
    border: `1px solid ${t.colors.cardBorder}`,
    borderRadius: t.borderRadiusLg,
    boxShadow: t.colors.cardShadow,
    padding: padding ?? t.spacing.lg,
    boxSizing: "border-box",
  };
  return <div style={style}>{children}</div>;
}
